import React, { Component } from "react";
import { SignoutCallbackComponent } from "redux-oidc";
import userManager from "../../helpers/UserManagerHelper";
import { Paths } from "../../constants/UrlConstants";
import { withRouter } from "react-router-dom";
import { setExitSurveyUrlFromType } from "./loggedOutActions";
import { connect } from "react-redux";
import { setErrorMessage } from "../../actions/error/errorActions";
import { decodeB2CErrorMessage } from "../../helpers/B2CErrorMessageDecoder";
import { redirectToErrorPageMessage } from "../../logging/CommonLogMessages";
import { trackException } from "../../logging/AppInsightsLogger";

const setExitSurveyUrlFromTypeAndRedirect = (
  { state = {} },
  setExitSurveyUrlFromType,
  history
) => {
  setExitSurveyUrlFromType(state.exitSurveyType);
  history.push(Paths.LoggedOut);
};

export class LogoutCallback extends Component {
  errorCallback = (error) => {
    let errorDescription =
      error && decodeB2CErrorMessage(error.error_description);
    this.props.setErrorMessage(errorDescription);
    trackException(
      redirectToErrorPageMessage,
      `Something went wrong while logging out. Error: ${JSON.stringify(
        errorDescription
      )}`
    );
    this.props.history.push(Paths.Error);
  };
  render() {
    const { setExitSurveyUrlFromType, history } = { ...this.props };
    return (
      <SignoutCallbackComponent
        successCallback={(user) =>
          setExitSurveyUrlFromTypeAndRedirect(
            user,
            setExitSurveyUrlFromType,
            history
          )
        }
        errorCallback={this.errorCallback}
        userManager={userManager}
      >
        <div>Redirecting...</div>
      </SignoutCallbackComponent>
    );
  }
}

export default withRouter(
  connect(null, { setExitSurveyUrlFromType, setErrorMessage })(LogoutCallback)
);
